export default __webpack_public_path__ + "static/media/Subtraction1.d3942cfe.svg";